import {
  getGochiChildFoodListData,
  getGochiChildFoodListDetailData,
  addGochiChildFoodListData,
  editGochiChildFoodListData,
  deleteGochiChildFoodListData,
  //   showHideGochiMenuData,
  addGochiChildFoodListImageData,
  getChildFoodGroupsData,
  getChildFoodShopsData
} from '../libs/apis/GochiChildFoodApi';

export const GET_GOCHI_CHILD_FOOD_REQUEST = 'GET_GOCHI_CHILD_FOOD_REQUEST';
export const GET_GOCHI_CHILD_FOOD_SUCCESS = 'GET_GOCHI_CHILD_FOOD_SUCCESS';
export const GET_GOCHI_CHILD_FOOD_FAILURE = 'GET_GOCHI_CHILD_FOOD_FAILURE';

export const GET_GROUPS_REQUEST = 'GET_GROUPS_REQUEST';
export const GET_GROUPS_SUCCESS = 'GET_GROUPS_SUCCESS';
export const GET_GROUPS_FAILURE = 'GET_GROUPS_FAILURE';

export const GET_SHOPS_REQUEST = 'GET_SHOPS_REQUEST';
export const GET_SHOPS_SUCCESS = 'GET_SHOPS_SUCCESS';
export const GET_SHOPS_FAILURE = 'GET_SHOPS_FAILURE';

export const GET_GOCHI_CHILD_FOOD_DETAIL_REQUEST =
  'GET_GOCHI_CHILD_FOOD_DETAIL_REQUEST';
export const GET_GOCHI_CHILD_FOOD_DETAIL_SUCCESS =
  'GET_GOCHI_CHILD_FOOD_DETAIL_SUCCESS';
export const GET_GOCHI_CHILD_FOOD_DETAIL_FAILURE =
  'GET_GOCHI_CHILD_FOOD_DETAIL_FAILURE';

export const ADD_GOCHI_CHILD_FOOD_REQUEST = 'ADD_GOCHI_CHILD_FOOD_REQUEST';
export const ADD_GOCHI_CHILD_FOOD_SUCCESS = 'ADD_GOCHI_CHILD_FOOD_SUCCESS';
export const ADD_GOCHI_CHILD_FOOD_FAILURE = 'ADD_GOCHI_CHILD_FOOD_FAILURE';

export const EDIT_GOCHI_CHILD_FOOD_REQUEST = 'EDIT_GOCHI_CHILD_FOOD_REQUEST';
export const EDIT_GOCHI_CHILD_FOOD_SUCCESS = 'EDIT_GOCHI_CHILD_FOOD_SUCCESS';
export const EDIT_GOCHI_CHILD_FOOD_FAILURE = 'EDIT_GOCHI_CHILD_FOOD_FAILURE';

export const DELETE_GOCHI_CHILD_FOOD_REQUEST =
  'DELETE_GOCHI_CHILD_FOOD_REQUEST';
export const DELETE_GOCHI_CHILD_FOOD_SUCCESS =
  'DELETE_GOCHI_CHILD_FOOD_SUCCESS';
export const DELETE_GOCHI_CHILD_FOOD_FAILURE =
  'DELETE_GOCHI_CHILD_FOOD_FAILURE';

// export const SHOW_HIDE_GOCHI_MENU_REQUEST = 'SHOW_HIDE_GOCHI_MENU_REQUEST';
// export const SHOW_HIDE_GOCHI_MENU_SUCCESS = 'SHOW_HIDE_GOCHI_MENU_SUCCESS';
// export const SHOW_HIDE_GOCHI_MENU_FAILURE = 'SHOW_HIDE_GOCHI_MENU_FAILURE';

export const ADD_GOCHI_CHILD_FOOD_IMAGE_REQUEST =
  'ADD_GOCHI_CHILD_FOOD_IMAGE_REQUEST';
export const ADD_GOCHI_CHILD_FOOD_IMAGE_SUCCESS =
  'ADD_GOCHI_CHILD_FOOD_IMAGE_SUCCESS';
export const ADD_GOCHI_CHILD_FOOD_IMAGE_FAILURE =
  'ADD_GOCHI_CHILD_FOOD_IMAGE_FAILURE';

export const getGochiChildFoodLists = params => dispatch => {
  dispatch({ type: GET_GOCHI_CHILD_FOOD_REQUEST });
  return getGochiChildFoodListData(params)
    .then(response =>
      dispatch({
        type: GET_GOCHI_CHILD_FOOD_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_GOCHI_CHILD_FOOD_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const getGochiChildFoodListDetail = childFoodId => dispatch => {
  dispatch({ type: GET_GOCHI_CHILD_FOOD_DETAIL_REQUEST });
  return getGochiChildFoodListDetailData(childFoodId)
    .then(response =>
      dispatch({
        type: GET_GOCHI_CHILD_FOOD_DETAIL_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_GOCHI_CHILD_FOOD_DETAIL_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const addGochiChildFoodList = params => dispatch => {
  dispatch({ type: ADD_GOCHI_CHILD_FOOD_REQUEST });
  return addGochiChildFoodListData(params)
    .then(response =>
      dispatch({
        type: ADD_GOCHI_CHILD_FOOD_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: ADD_GOCHI_CHILD_FOOD_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const editGochiChildFoodList = (childFoodId, params) => dispatch => {
  dispatch({ type: EDIT_GOCHI_CHILD_FOOD_REQUEST });
  return editGochiChildFoodListData(childFoodId, params)
    .then(response =>
      dispatch({
        type: EDIT_GOCHI_CHILD_FOOD_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: EDIT_GOCHI_CHILD_FOOD_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const deleteGochiChildFoodList = childFoodId => dispatch => {
  dispatch({ type: DELETE_GOCHI_CHILD_FOOD_REQUEST });
  return deleteGochiChildFoodListData(childFoodId)
    .then(response =>
      dispatch({
        type: DELETE_GOCHI_CHILD_FOOD_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: DELETE_GOCHI_CHILD_FOOD_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

// export const showHideGochiMenu = (menuId, paramShowHide) => dispatch => {
//   dispatch({ type: SHOW_HIDE_GOCHI_MENU_REQUEST });
//   return showHideGochiMenuData(menuId, paramShowHide)
//     .then(response =>
//       dispatch({
//         type: SHOW_HIDE_GOCHI_MENU_SUCCESS,
//         payload: response.data
//       })
//     )
//     .catch(error =>
//       dispatch({
//         type: SHOW_HIDE_GOCHI_MENU_FAILURE,
//         payload: error.response,
//         error: true
//       })
//     );
// };

export const addGochiChildFoodListImage = (childFoodId, params) => dispatch => {
  dispatch({ type: ADD_GOCHI_CHILD_FOOD_IMAGE_REQUEST });
  return addGochiChildFoodListImageData(childFoodId, params)
    .then(response =>
      dispatch({
        type: ADD_GOCHI_CHILD_FOOD_IMAGE_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: ADD_GOCHI_CHILD_FOOD_IMAGE_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const getChildFoodGroups = params => dispatch => {
  dispatch({ type: GET_GROUPS_REQUEST });
  return getChildFoodGroupsData(params)
    .then(response =>
      dispatch({
        type: GET_GROUPS_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_GROUPS_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const getChildFoodShops = params => dispatch => {
  dispatch({ type: GET_SHOPS_REQUEST });
  return getChildFoodShopsData(params)
    .then(response =>
      dispatch({
        type: GET_SHOPS_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_GROUPS_FAILURE,
        payload: error.response,
        error: true
      })
    );
};
